import MainLayout from '@layouts/main-layout'
import CartTemplate from '@modules/cart/templates'
import { ReactElement } from 'react'
import { NextPageWithLayout } from 'types/global'

const Cart: NextPageWithLayout = () => {
  return (
    <>
      <CartTemplate />
    </>
  )
}

Cart.getLayout = (page: ReactElement) => {
  return <MainLayout>{page}</MainLayout>
}

export default Cart
